export default __webpack_public_path__ + "static/media/img_0.275bae1c.png";